import { GrouperServiceConverter } from 'src/services/converters/GrouperServiceConverter';
import { GetGrouperDataResponse } from 'src/contracts/getGrouperDataResponse';
import { GrouperData } from 'src/contracts/grouperData';
import { CalculateDrgRequestDto } from 'src/contracts/calculateDrgRequestDto';
import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import { AxiosService } from 'src/services/AxiosService';
import { DischargeStatus } from 'src/contracts/discharge-status';
import {DrgInfo} from 'src/contracts/drgInfo';

/**
 * Service for interacting with the backend Grouper V3 service.
 */
export class GrouperService extends AxiosService {

  async getGrouperData(): Promise<GrouperData> {
    const result =  await this.axiosCall<GetGrouperDataResponse>({
      method: 'get',
      url: `/visit/${this.visitId}/grouper_v3`,
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return <GrouperData>GrouperServiceConverter.convertGrouperData(<GetGrouperDataResponse>result.data);
  }

  async getDischargeStatuses(): Promise<DischargeStatus[]> {

    const result =  await this.axiosCall<KeyValueMap>({
      method: 'get',
      url: '/grouper/resources/discharge-statuses',
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    if (!result.data) {
      console.log('[GrouperService] Error: No discharge statuses available');
      return [];
    }

    const dischargeStatuses: DischargeStatus[] = [];
    for (const key in result.data) {
      dischargeStatuses.push({ code: key, description: result.data[key] });
    }

    return dischargeStatuses;
  }
  async calculateDrg(calculateDrgRequestDto: CalculateDrgRequestDto | undefined): Promise<DrgResponseDto[] | undefined> {
    console.log('[GrouperService] calculateDrg: ' + JSON.stringify(calculateDrgRequestDto));
    const result =  await this.axiosCall<DrgResponseDto[]>({
      method: 'post',
      data: calculateDrgRequestDto,
      url: `/visit/${this.visitId}/grouper_v3/calculate`,
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return result.data;
    // return MockDrgResponseDto;
  }

  async saveDrg(drgDto: any | undefined): Promise<DrgInfo[] | undefined> {
    console.log('[GrouperService] saveDrg: ' + JSON.stringify(drgDto));
    const result =  await this.axiosCall<DrgInfo[]>({
      method: 'post',
      data: drgDto,
      url: `/visit/${this.visitId}/grouper_v3/drg`,
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }
}

interface KeyValueMap { [key: string]: string }
